// extracted by mini-css-extract-plugin
module.exports = {"hidden":"messageContents_hidden__a_IT4","textEmphasis":"messageContents_textEmphasis__HGp_C","title":"messageContents_title__doGAZ","message":"messageContents_message__AjqIk"};